/**
 * ExecPro360 - Copyright (c) 2026 Emmanuel TESTE
 * Tous droits réservés - Logiciel propriétaire
 */
import LegalLayout from "../components/LegalLayout";
import {
  PUBLISHER_NAME, PUBLISHER_LEGAL_FORM, PUBLISHER_RCS, PUBLISHER_ADDRESS, CONTACT_EMAIL,
} from "../config/legal";

export default function Privacy() {
  return (
    <LegalLayout current="confidentialite" title="Politique de confidentialité" updated="Dernière mise à jour : octobre 2026 · ExecPro360">
      <p>
        Cette politique explique en langage clair quelles données nous collectons sur ExecPro360,
        pourquoi, combien de temps nous les gardons, et comment faire valoir vos droits.
      </p>

      <h2>1. Qui traite vos données</h2>
      <p>
        Le responsable du traitement est {PUBLISHER_NAME}, {PUBLISHER_LEGAL_FORM} ({PUBLISHER_RCS},
        siège social : {PUBLISHER_ADDRESS} —{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>), éditeur du site.
      </p>

      <h2>2. Quelles données sont collectées</h2>
      <p>À l'inscription :</p>
      <ul>
        <li>Email et mot de passe (stocké haché, jamais en clair)</li>
        <li>Nom du contact et numéro de téléphone</li>
        <li>Taille de l'entreprise</li>
        <li>Fonction dans l'entreprise (optionnel)</li>
      </ul>
      <p>
        Puis, au fil de l'utilisation du produit : les données que vous saisissez vous-même
        (factures, clients, fournisseurs, écritures comptables, et tout autre contenu métier que
        vous créez dans l'application).
      </p>

      <h2>3. Pourquoi nous collectons ces données</h2>
      <ul>
        <li>Fournir le service : faire fonctionner votre compte et les fonctionnalités de gestion comptable/facturation</li>
        <li>Qualifier les prospects pour un suivi commercial (taille d'entreprise, fonction) — jamais de revente à des tiers</li>
      </ul>

      <h2>4. Durée de conservation</h2>
      <p>
        Pendant votre essai gratuit (14 jours), toutes vos données sont pleinement accessibles.
        À l'expiration de l'essai sans abonnement actif, votre compte passe en lecture seule :
        vous pouvez toujours consulter et exporter vos données, mais plus les modifier. Sept jours
        plus tard (soit 21 jours après le début de l'essai), votre société est archivée.
      </p>
      <p>
        <strong>Aucune suppression automatique</strong> n'a lieu à ce stade — une suppression
        réelle et définitive nécessite une décision et une procédure manuelle de notre part.
        Avant l'archivage, un lien pour exporter vos données comptables (format FEC) et la liste
        de vos factures (CSV) est disponible directement dans le bandeau affiché sur votre
        compte dès le passage en lecture seule.
      </p>

      <h2>5. Vos droits</h2>
      <p>
        Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement et
        de portabilité de vos données. La rectification de vos informations de société est
        possible directement depuis l'application (Administration → Sociétés). Pour toute autre
        demande — accès à l'ensemble de vos données, effacement, ou export dans un format
        particulier — écrivez-nous à{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>. Une
        demande d'effacement fait l'objet d'un traitement manuel de notre part (cf. section 4) ;
        nous répondons dans un délai maximum d'un mois.
      </p>

      <h2>6. Sous-traitants et tiers</h2>
      <ul>
        <li><strong>Hetzner Online GmbH</strong> (Allemagne) — hébergement de l'application et des données</li>
        <li><strong>Stripe</strong> — traitement des paiements. L'ouverture des abonnements payants est actuellement gelée : aucun paiement n'est traité pour le moment</li>
        <li><strong>Brevo</strong> — envoi des emails transactionnels (confirmation d'inscription, rappels de fin d'essai)</li>
        <li><strong>Mistral AI</strong> (France) — seul fournisseur des fonctions d'intelligence artificielle : lecture automatique des factures importées (y compris par email), analyse des documents archivés, traduction des documents, lecture des bons de commande PDF, assistant et rapport mensuel IA, analyse budgétaire, aide à la prospection et assistant de la page d'accueil. Seuls le document ou la demande concernés et le contexte nécessaire à la réponse lui sont transmis</li>
      </ul>

      <h2>7. Cookies</h2>
      <p>
        ExecPro360 n'utilise aujourd'hui qu'un cookie/jeton de session strictement nécessaire à la
        connexion. Aucun outil de mesure d'audience (Google Analytics ou équivalent) n'est
        installé à ce jour. Si un tel outil est ajouté à l'avenir, un bandeau de consentement sera
        mis en place au préalable et cette politique sera mise à jour en conséquence.
      </p>

      <h2>8. Contact</h2>
      <p>
        Pour toute question relative à cette politique ou à vos données :{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </p>
    </LegalLayout>
  );
}
